module.exports = __webpack_public_path__ + "img/home.966f6ef4.jpeg";